import LayoutView from "../LayoutView";

interface HomeProps {}

let Home: React.FunctionComponent<HomeProps> = () => {
  return <div></div>;
};

export default Home;
